import Axios from "../../../../networking/intraceptor";
import * as routeName from '../../../../routes/routeName';
import * as endPoints from '../../../../networking/urlEndPoints';
import { showToast } from "../../../../utils/helper/helper";
import { PreviewPdf } from "../../../../utils/helper/helper";
// Helper function to generate action types with REQUEST, SUCCESS, and FAILURE
const createActionTypes = (base) => ({
    REQUEST: `${base}_REQUEST`,
    SUCCESS: `${base}_SUCCESS`,
    FAILURE: `${base}_FAILURE`
});

// Action Types
const actionTypes = {
    ADD_BLISTER_PACKAGING_DATA: createActionTypes('ADD_BLISTER_PACKAGING_DATA'),
    TODAY_PROCESSED_DATA: createActionTypes('TODAY_PROCESSED_DATA'),
    GET_PATIENTS_PRESCRIPTIONS: createActionTypes('GET_PATIENTS_PRESCRIPTIONS'),
    PRN_PROCESSING: createActionTypes('PRN_PROCESSING'),
    PACKING_LIQUID_PROCESSING: createActionTypes('PACKING_LIQUID_PROCESSING'),
    ALL_ORDERS: createActionTypes('ALL_ORDERS'),
    PACKMED_FILES: createActionTypes('PACKMED_FILES'),
    ALL_INVOICES: createActionTypes('ALL_INVOICES'),
    INVOICE_DETAILS: createActionTypes('INVOICE_DETAILS'),
    VIEW_ORDER_DETAILS: createActionTypes('VIEW_ORDER_DETAILS'),
    ORDER_DETAILS: createActionTypes('ORDER_DETAILS'),
    SYNC_PACMED_RECORDS: createActionTypes('SYNC_PACMED_RECORDS'),
    SYNC_PACMED_PROCESSING: createActionTypes('SYNC_PACMED_PROCESSING'),
    PATIENT_ORDER_DETAILS: createActionTypes('PATIENT_ORDER_DETAILS'),
    FETCH_PARTIAL_ORDERS: createActionTypes('FETCH_PARTIAL_ORDERS'),
    STOCK_LOG: createActionTypes('STOCK_LOG'),
    DELETE_ALL_PATIENT_RECORDS: createActionTypes('DELETE_ALL_PATIENT_RECORDS'),
    DELETE_FINAL_ORDER: createActionTypes('DELETE_FINAL_ORDER'),
    UPDATE_PACMED_RECORDS: createActionTypes('UPDATE_PACMED_RECORDS'),
    INVOICE_LOGS: createActionTypes('INVOICE_LOGS')
};

// Action Creators
const createAction = (type, payload = {}) => ({ type, payload });

//TODAYS PROCESSED DATA 
export const FetchTodayProcessedData = ({ fetchType, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.TODAY_PROCESSED_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const { status, data } = await Axios.get(endPoints.blisterPackaging_todayProcessedData + `?page=${pageNumber}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.TODAY_PROCESSED_DATA.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));
            return;
        }
    } catch (error) {
        dispatch(createAction(actionTypes.TODAY_PROCESSED_DATA.FAILURE, {
            error: error?.response?.data?.message || error.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
};

//fetch patients prescriptions
export const FetchPatientsPrescriptions = ({ fetchType,
    patientId,
    setLoadingPatients,
    setPatientPrescriptionsData,
}) => async (dispatch) => {

    try {
        setLoadingPatients(prev => ({ ...prev, [patientId]: true }));
        dispatch(createAction(actionTypes.GET_PATIENTS_PRESCRIPTIONS.REQUEST, {
            requestType: fetchType
        }));

        const { status, data } = await Axios.get(endPoints.blisterPackaging_patientsPrescriptions + `?patient_id=${patientId}&no_of_records=20`);
        if (status === 200) {
            dispatch(createAction(actionTypes.GET_PATIENTS_PRESCRIPTIONS.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));

            setPatientPrescriptionsData(prev => ({
                ...prev,
                [patientId]: data?.data
            }));

            return;
        }
    } catch (error) {
        dispatch(createAction(actionTypes.GET_PATIENTS_PRESCRIPTIONS.FAILURE, {
            error: error?.response?.data?.message || error?.message || 'Something went wrong',
            requestType: fetchType
        }));
    } finally {
        setLoadingPatients(prev => ({ ...prev, [patientId]: false }));
    };
}


//fetch patients prescriptions
export const FetchPatientOrderDetails = ({ fetchType,
    patientId,
    setLoadingPatients,
    setPatientPrescriptionsData,
    orderId
}) => async (dispatch) => {

    try {
        setLoadingPatients(prev => ({ ...prev, [patientId]: true }));
        dispatch(createAction(actionTypes.PATIENT_ORDER_DETAILS.REQUEST, {
            requestType: fetchType
        }));

        const { status, data } = await Axios.get(`${endPoints.blisterPackaging_patientOrderDetails}?patient_id=${patientId}&order_id=${orderId}`);
        if (status === 200) {
            dispatch(createAction(actionTypes.PATIENT_ORDER_DETAILS.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));

            setPatientPrescriptionsData(prev => ({
                ...prev,
                [patientId]: data?.data
            }));


            return;
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PATIENT_ORDER_DETAILS.FAILURE, {
            error: error?.response?.data?.message || error?.message || 'Something went wrong',
            requestType: fetchType
        }));
    } finally {
        setLoadingPatients(prev => ({ ...prev, [patientId]: false }));
    };
}


//delete prescription
export const DeletePrescription = ({ fetchType,
    payload,
    patientId,
    setPatientPrescriptionsData,
    setLoadingPatients,
    setPatientData,
    pageNumber }) => async (dispatch) => {
        try {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
                requestType: fetchType
            }));

            const url = fetchType === 'deletePrescription' ? endPoints.blisterPackaging_deletePrescription : endPoints.blisterPackaging_deletePatientWiseRecord
            const { status, data } = await Axios.delete(url, { params: payload });

            if (status === 200) {
                dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                    data: data?.data,
                    requestType: fetchType
                }));

                if (fetchType === 'deletePrescription') {
                    dispatch(FetchPatientsPrescriptions({
                        fetchType: 'patientsPrescriptions',
                        patientId: patientId,
                        setPatientPrescriptionsData,
                        setLoadingPatients
                    }))
                }

                else if (fetchType === 'deletePatient') {
                    dispatch(FetchTodayProcessedData({
                        fetchType: 'todayProcessedData',
                        pageNumber
                    }))
                }

                setPatientData(prevState => ({
                    ...prevState,
                    deletePrescription: false,
                    type: null
                }))
                return;
            }

        } catch (error) {
            showToast('Something went wrong while deleting please try again', 'error')
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
                error: error?.response?.data?.message || error?.message || 'Something went wrong',
                requestType: fetchType
            }));
        }
    }


// Fetches PRN (Pro Re Nata/as needed) processing data
export const FetchPackgingPRN_Processing = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PRN_PROCESSING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(endPoints.blisterPackaging_prnProcessingData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PRN_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PRN_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches liquid medication processing data
export const FetchPackgingLiquidProcessing = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(endPoints.blisterPackaging_liquidProcessingData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKING_LIQUID_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Generate new order
export const GenerateNewOrder = ({ fetchType, navigate, pharmacyId }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));

        const url = endPoints.blisterPackaging_createNewOrder
        const { status, data } = await Axios.post(url);
        if (status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: data?.data,
                requestType: fetchType
            }));

            if (pharmacyId === 865) {
                navigate(routeName.pharmacy_blister_packaging_packmed_files)
            }
            else {
                navigate(routeName.pharmacy_blister_packaging_orders)
            }

            return;
        }

    } catch (error) {
        showToast('Something went wrong while creating new order please try again', 'error')
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data?.message || error?.message || 'Something went wrong',
            requestType: fetchType
        }));
    }
}

// Retrieves all incoming orders data
export const FetchAllIncomingOrders = ({ fetchType, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ALL_ORDERS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const order_status = formData?.status?.label === 'All' ? 0 : formData?.status?.label?.toLowerCase()
        const response = await Axios.get(`${endPoints.blisterPackaging_allIncomingOrders}?order_status=${order_status}&page=${pageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ALL_ORDERS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ALL_ORDERS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches packmed files data
export const FetchPackmedFiles = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.PACKMED_FILES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(endPoints.blisterPackaging_pacmed_files);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.PACKMED_FILES.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.PACKMED_FILES.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while deleting records please try again later',
            requestType: fetchType
        }));
    }
}

// Downloads packmed order text file in plain text format
export const PackMedTextFileDownload = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_download_order_text}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

            // Convert base64 to text and download
            const content = atob(response?.data?.file_base64);
            const blob = new Blob([content], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = response?.data?.file_name || 'download.txt';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading file please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Downloads packmed order files as a zip archive
export const PackMedZipFileDownload = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        // Modify the Axios request to handle binary data
        const response = await Axios.get(`${endPoints.blisterPackaging_download_order_text}/${id}?zipdownload=${1}`, {
            responseType: 'arraybuffer'  // This is crucial for binary data
        });

        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            // Create blob directly from the array buffer
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `order_${id}.zip`; // You can set a specific name if provided by the API
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading zip please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Downloads specific package file based on package number
export const PackMedPackageDownload = ({ fetchType, id, packageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_download_order_text}/${id}?package_number=${packageNumber}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));

            // Convert base64 to text and download
            const content = atob(response?.data?.file_base64);
            const blob = new Blob([content], { type: 'text/plain' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = response?.data?.file_name || 'download.txt';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        showToast('Oops we got an error while downloading file please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches all invoices data
export const FetchAllInvoices = ({ fetchType, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ALL_INVOICES.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            payment_status: formData?.payment_status?.label === 'All Payment Status' ? 0 : formData?.payment_status?.label?.toLowerCase(),
            invoice_status: formData?.invoice_status?.label === 'All Invoice Status' ? 0 : formData?.invoice_status?.label?.toLowerCase(),
            search_date: formData?.date,
            pharmacy_details: formData?.pharmacy_details,
            page: pageNumber
        }
        const response = await Axios.get(endPoints.blisterPackaging_allInvoices, { params });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ALL_INVOICES.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ALL_INVOICES.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Fetches invoice details
export const FetchInvoiceDetails = ({ fetchType, invoiceId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVOICE_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_invoiceDetails}/${invoiceId}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.INVOICE_DETAILS.SUCCESS, {
                data: response?.data.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice pdf please try again later', 'error');
        dispatch(createAction(actionTypes.INVOICE_DETAILS.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice pdf please try again later',
            requestType: fetchType
        }));
    }
}

//View Invoice PDF
export const ViewInvoicePDF = ({ fetchType, invoiceId }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_viewInvoicePDF}/${invoiceId}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.data?.invoice_pdf);
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice pdf please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice pdf please try again later',
            requestType: fetchType
        }));
    }
}
//Update Drug Stock
export const HandleChangeOrderStatus = ({ payload, orderId, viewType, pharmacyId, setLoading, setShowModal, showModal }) => async (dispatch) => {
    try {
        if (typeof setLoading === 'function') {
            setLoading(true)
        }
        const response = await Axios.post(`${endPoints.blisterPackaging_changeOrderStatus}`, payload);
        if (response.status === 200) {
            showToast(response?.data?.message, 'success');

            if (typeof setShowModal === 'function' && payload?.order_status == 'delivered') {
                setShowModal({ ...showModal, status: false })
            }

            if (orderId && viewType !== 'stockview') {
                dispatch(FetchOrderDetails({
                    fetchType: 'orderDetails',
                    id: orderId,
                    viewType: viewType,
                    pageNumber: 1
                }))
            } else if (orderId && viewType == 'stockview' && pharmacyId == 1502) {
                dispatch(FetchStockWiseOrderDetails({
                    fetchType: 'stockViewOrderDetails',
                    id: orderId
                }))
            }

            if (orderId) {
                dispatch(FetchViewOrderDetails({
                    fetchType: 'viewOrderDetails',
                    id: orderId
                }))
            }
            showToast('Status updated successfully', 'success');
            if (typeof setLoading === 'function') {
                setLoading(false)
            }
        }
    } catch (error) {
        showToast('Oops we got an error while updating status please try again later', 'error');
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
    }
}


//Regenerate Invoice
export const HandleRegenerateInvoice = ({ payload, fetchType, setShowModal, showModal }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.post(`${endPoints.blisterPackaging_regenerateInvoice}`, payload);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));

            if (payload?.order_id) {
                dispatch(FetchViewOrderDetails({
                    fetchType: 'viewOrderDetails',
                    id: payload?.order_id
                }))
            }
            setShowModal({ ...showModal, genrate: false })
        }
    } catch (error) {
        showToast(error?.response?.data?.error || 'Oops we got an error while regenerating invoice please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}


//Invoice Payment Status Update
export const ChangePaymentStatus = ({ fetchType, payloadData, setShowModal, pageNumber, formData }) => async (dispatch) => {

    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));

    try {
        const response = await Axios.post(`${endPoints.blisterPackaging_updateInvoiceStatus}`, payloadData);
        if (response.status === 200) {

            dispatch(FetchAllInvoices({ fetchType: 'allInvoices', pageNumber, formData }))
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            setShowModal(false)
            showToast('Status updated successfully', 'success');
        }
    } catch (error) {
        // console.log(error)
        showToast('Oops we got an error while fetching invoice Paid or Unpaid Status please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while fetching invoice Paid or Unpaid Status please try again later',
            requestType: fetchType
        }));
    }
}

//Send Invoice Email
export const SendInvoiceEmail = ({ fetchType, payloadData, setShowModal }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${endPoints.blisterPackaging_sendInvoiceEmail}`, payloadData);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            setShowModal(false)
            showToast('Email sent successfully', 'success');
        }
    } catch (error) {
        showToast('Oops we  an error while sending invoice email please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'Oops we got an error while sending invoice email please try again later',
            requestType: fetchType
        }));
    }
}


// Retrieves detailed order information with optional view type
export const FetchOrderDetails = ({ fetchType, id, viewType, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {

        const params = {
            viewType: viewType,
        }
        if (viewType == 'patientview') {
            params.page = pageNumber
        }

        const response = await Axios.get(`${endPoints.blisterPackaging_viewOrderDetails}/${id}`, { params });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}
// Retrieves detailed order information with optional view type
export const FetchViewOrderDetails = ({ fetchType, id }) => async (dispatch) => {
    dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_orderDetails}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.VIEW_ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Sync Pacmed Records
export const SyncPacmedRecords = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.SYNC_PACMED_RECORDS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${endPoints.blisterPackaging_syncPacmedRecords}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.SYNC_PACMED_RECORDS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            // dispatch(SyncPacmedProcessing({ fetchType: 'syncPacmedProcessing' }))
            dispatch(FetchTodayProcessedData({
                fetchType: 'todayProcessedData',
                pageNumber: 1
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.SYNC_PACMED_RECORDS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Sync Pacmed Records
export const SyncPacmedProcessing = ({ fetchType }) => async (dispatch) => {
    dispatch(createAction(actionTypes.SYNC_PACMED_PROCESSING.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_checkPacmedProgress}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.SYNC_PACMED_PROCESSING.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
            if (response?.data?.progress === 100) {
                dispatch(FetchTodayProcessedData({
                    fetchType: 'todayProcessedData',
                    pageNumber: 1
                }))
            }
        }
    } catch (error) {
        dispatch(createAction(actionTypes.SYNC_PACMED_PROCESSING.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

// Retrieves stock wise order details
export const FetchStockWiseOrderDetails = ({ fetchType, id, filterBy }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ORDER_DETAILS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const params = {
            order_id: id

        }

        if (filterBy) {
            params.filter_by = 'pending_for_update'
        }

        const response = await Axios.post(`${endPoints.blisterPackaging_orderStockData}`, params);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.ORDER_DETAILS.SUCCESS, {
                data: response.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.ORDER_DETAILS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Invoice Payment Status Update
export const FetchStockDrugs = ({ fetchType, payload }) => async (dispatch) => {
    dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${endPoints.blisterPackaging_stockDrugs}`, { params: payload });

        if (response.status === 200) {
            if (response?.data?.drugs?.length > 0) {
                dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                    data: response?.data?.drugs,
                    requestType: 'drugs'
                }));
            } else {
                dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                    data: response?.data?.message,
                    requestType: fetchType
                }));
            }
        }
    } catch (error) {
        showToast('Oops we got an error while fetching stock drugs please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Update Drug Stock
export const HandleUpdateDrug = ({ payload, setShowModal, setLoading, setActiveTooltip, filterBy }) => async (dispatch) => {

    try {
        if (typeof setLoading === 'function') {
            setLoading(true)
        }
        const response = await Axios.post(`${endPoints.blisterPackaging_updateDrugStock}`, payload);
        if (response.status === 200) {
            showToast(response?.data?.message, 'success');
            dispatch(FetchStockWiseOrderDetails({
                fetchType: 'stockViewOrderDetails',
                id: payload?.order_id,
                filterBy: filterBy
            }))
            setShowModal((prev) => ({ ...prev, drug: false }))
            setActiveTooltip(null)
            if (typeof setLoading === 'function') {
                setLoading(false)
            }
        }
    } catch (error) {
        showToast('Oops we got an error while updating drug stock please try again later', 'error');
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
    }
}

//Update Drug Stock
export const HandleGetUpdatedDrugs = ({ payload, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${endPoints.blisterPackaging_get_updated_drugs}/${payload?.order_id}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.base64_pdf)
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {

        showToast('Oops we got an error while fetching updated drugs please try again later', 'error');

        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Fetch Partial Orders
export const FetchPartialOrders = ({ fetchType, id }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${endPoints.blisterPackaging_partial_orders}/${id}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.FETCH_PARTIAL_ORDERS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Handle Partial Order
export const HandleGetPartialOrder = ({ payload, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${endPoints.blisterPackaging_partial_order_pdf}/${payload?.order_id}`);
        if (response.status === 200) {
            PreviewPdf(response?.data?.pdf_base64)
            dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {

        showToast('Oops we got an error while fetching partial order please try again later', 'error');
        dispatch(createAction(actionTypes.ADD_BLISTER_PACKAGING_DATA.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

//Handle Get Stock Log
export const HandleGetStockLog = ({ orderId, fetchType }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.STOCK_LOG.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.get(`${endPoints.blisterPackaging_stockLog}?order_id=${orderId}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.STOCK_LOG.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.STOCK_LOG.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const DeleteAllPatientRecords = ({ fetchType, payload, setPatientData, pageNumber, setDeleteAllRecords }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.DELETE_ALL_PATIENT_RECORDS.REQUEST, {
            requestType: fetchType
        }));
        const response = await Axios.post(`${endPoints.blisterPackaging_deleteMultiplebpackPatient}`, { patient_ids: payload });
        if (response.status === 200) {
            dispatch(createAction(actionTypes.DELETE_ALL_PATIENT_RECORDS.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
            setDeleteAllRecords([])
            dispatch(FetchTodayProcessedData({
                fetchType: 'todayProcessedData',
                pageNumber: pageNumber
            }))
            setPatientData(prevState => ({
                ...prevState,
                deleteAllPatientRecords: false,
                type: null
            }))
        }
    } catch (error) {
        dispatch(createAction(actionTypes.DELETE_ALL_PATIENT_RECORDS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
        // showToast('Something went wrong', 'error');
    }
}

export const DeleteFinalOrder = ({ fetchType, payload, formData, pageNumber }) => async (dispatch) => {
    dispatch(createAction(actionTypes.DELETE_FINAL_ORDER.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.post(`${endPoints.blisterPackaging_deleteFinalOrder}`, payload);
        if (response.status === 200) {
            dispatch(FetchAllIncomingOrders({
                fetchType: 'allOrders',
                pageNumber: pageNumber,
                formData: formData
            }))
            dispatch(createAction(actionTypes.DELETE_FINAL_ORDER.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.DELETE_FINAL_ORDER.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const UpdatePacmedRecords = ({ fetchType, payload, setPatientData }) => async (dispatch) => {
    try {
        dispatch(createAction(actionTypes.UPDATE_PACMED_RECORDS.REQUEST, {
            requestType: fetchType
        }));

        const response = await Axios.post(`${endPoints.blisterPackaging_updatePacmedRecords}`, payload);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.UPDATE_PACMED_RECORDS.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
            showToast('Records updated successfully', 'success');
            setPatientData(prevState => ({
                ...prevState,
                updatePacmedRecords: false,
                type: null
            }))
        }
    } catch (error) {
        showToast('Something went wrong', 'error');
        dispatch(createAction(actionTypes.UPDATE_PACMED_RECORDS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const CheckedByUserOrder = ({  payload, setCheckedOrders }) => async (dispatch) => {
    try {
        const { status, data } = await Axios.post(`${endPoints.blisterPackaging_checkedByUserOrder}`, payload)
        if (status === 200) {
            const confirmedData = data?.data?.orderData
            setCheckedOrders(prevCheckedOrders => { // Use the updater function!
                const uniqueAcknResponse = prevCheckedOrders?.filter(value => value.order_id !== confirmedData.order_id);
                return [...uniqueAcknResponse, confirmedData];
            })
        }
    } catch (error) {
        showToast(error?.response?.data?.message || error.message || 'Something went wrong', 'error')
    }
}

export const FetchInvoiceLogs = ({ fetchType, type }) => async (dispatch) => {
    dispatch(createAction(actionTypes.INVOICE_LOGS.REQUEST, {
        requestType: fetchType
    }));
    try {
        const response = await Axios.get(`${type === 'packaging' ? endPoints.packaging_pacmed_invoice_logs : endPoints.blisterPackaging_invoiceLogs}`);
        if (response.status === 200) {
            dispatch(createAction(actionTypes.INVOICE_LOGS.SUCCESS, {
                data: response?.data,
                requestType: fetchType
            }));
        }
    } catch (error) {
        dispatch(createAction(actionTypes.INVOICE_LOGS.FAILURE, {
            error: error?.response?.data || 'An error occurred.',
            requestType: fetchType
        }));
    }
}

export const DownloadInvoiceZip = ({ zip, setLoading, index }) => async (dispatch) => {
    try {
        const response = await Axios.get(`${zip}`);
        if (response.status === 200) {
            const data = response?.data?.data?.zip;
            // Check if data is base64 encoded
            if (typeof data === 'string') {
                // Convert base64 to binary array
                const binaryString = atob(data);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([bytes], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `invoice.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }

            // Reset individual loading state
            setLoading(prev => ({
                ...prev,
                pdfLoading: { ...prev.pdfLoading, [index]: false }
            }));

        }
    } catch (error) {
        showToast('Something went wrong while downloading invoice pdf', 'error');
        // Reset individual loading state on error too
        setLoading(prev => ({
            ...prev,
            pdfLoading: { ...prev.pdfLoading, [index]: false }
        }));
    }
}

export const DownloadInvoiceExcel = ({excel, setLoading, index}) => async (dispatch) => {
    try {
        const response = await Axios.get(`${excel}`);
        if (response.status === 200) {
            const data = response?.data?.data?.zip;
            // Check if data is base64 encoded
            if (typeof data === 'string') {
                // Convert base64 to binary array
                const binaryString = atob(data);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([bytes], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `invoice.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } 
            
            // Reset individual loading state
            setLoading(prev => ({ 
                ...prev, 
                excelLoading: { ...prev.excelLoading, [index]: false } 
            }));
        }
    } catch (error) {
        showToast('Something went wrong while downloading invoice excel', 'error');
        // Reset individual loading state on error too
        setLoading(prev => ({
            ...prev,
            excelLoading: { ...prev.excelLoading, [index]: false }
        }));
    }
}

export const DownloadInvoiceFile = ({ url, fileType, setLoading, index, loadingKey }) => async (dispatch) => {
    try {
        const response = await Axios.get(`${url}`);
        
        if (response.status === 200) {
            const data =  fileType === 'pdf' ? response?.data?.data?.invoice_pdf : response?.data?.data?.invoice_excel ;
            if (typeof data === 'string') {
                const binaryString = atob(data);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                const blob = new Blob([bytes], {
                    type: fileType === 'pdf'
                        ? 'application/pdf'
                        : fileType === 'excel'
                            ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                            : 'application/zip'
                });
                
                // Create URL for viewing
                const fileUrl = window.URL.createObjectURL(blob);
                
                // Open in new window/tab for viewing
                if (fileType === 'pdf') {
                    // For PDF, open in new window
                    window.open(fileUrl, '_blank');
                } else if (fileType === 'excel') {
                    // For Excel, you can either download or show a message
                    // Option 1: Download (current behavior)
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.download = `invoice.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    // Option 2: Show message that Excel files need to be downloaded
                    // alert('Excel files need to be downloaded to view. File has been downloaded.');
                }
                
                // Clean up URL after a delay
                setTimeout(() => {
                    window.URL.revokeObjectURL(fileUrl);
                }, 1000);
            }

            setLoading(prev => ({
                ...prev,
                [loadingKey]: { ...prev[loadingKey], [index]: false }
            }));
        }
    } catch (error) {
        showToast('Something went wrong while downloading invoice', 'error');
        setLoading(prev => ({
            ...prev,
            [loadingKey]: { ...prev[loadingKey], [index]: false }
        }));
    }
}






const stateKeys = [
    'addBlisterPackagingData',
    'todayProcessedData',
    'getPatientsPrescriptions',
    'prnProcessingData',
    'packgingLiquidProcessingData',
    'allOrders',
    'packmedFiles',
    'allInvoices',
    'invoiceDetails',
    'viewOrderDetails',
    'orderDetails',
    'syncPacmedRecords',
    'syncPacmedProcessing',
    'patientOrderDetails',
    'fetchPartialOrders',
    'stockLog',
    'deleteAllPatientRecords',
    'deleteFinalOrder',
    'updatePacmedRecords',
    'invoiceLogs'
];

const createDefaultState = () => ({
    loading: false,
    error: null,
    data: null,
    fetchType: null,
});

const initialState = stateKeys.reduce((acc, key) => {
    acc[key] = createDefaultState();
    return acc;
}, {});

// Helper function to update state
const updateState = (state, key, updates) => ({
    ...state,
    [key]: { ...state[key], ...updates }
});

// Map action prefixes to state keys
const actionPrefixMap = {
    ADD_BLISTER_PACKAGING_DATA: 'addBlisterPackagingData',
    TODAY_PROCESSED_DATA: 'todayProcessedData',
    GET_PATIENTS_PRESCRIPTIONS: 'getPatientsPrescriptions',
    PRN_PROCESSING: 'prnProcessingData',
    PACKING_LIQUID_PROCESSING: 'packgingLiquidProcessingData',
    ALL_ORDERS: 'allOrders',
    PACKMED_FILES: 'packmedFiles',
    ALL_INVOICES: 'allInvoices',
    INVOICE_DETAILS: 'invoiceDetails',
    VIEW_ORDER_DETAILS: 'viewOrderDetails',
    ORDER_DETAILS: 'orderDetails',
    SYNC_PACMED_RECORDS: 'syncPacmedRecords',
    SYNC_PACMED_PROCESSING: 'syncPacmedProcessing',
    PATIENT_ORDER_DETAILS: 'patientOrderDetails',
    FETCH_PARTIAL_ORDERS: 'fetchPartialOrders',
    STOCK_LOG: 'stockLog',
    DELETE_ALL_PATIENT_RECORDS: 'deleteAllPatientRecords',
    DELETE_FINAL_ORDER: 'deleteFinalOrder',
    UPDATE_PACMED_RECORDS: 'updatePacmedRecords',
    INVOICE_LOGS: 'invoiceLogs'
};

// Helper function to get updates based on action status
const getStatusUpdates = (status, payload) => ({
    REQUEST: { loading: true, data: null, error: null, fetchType: payload.requestType },
    SUCCESS: { loading: false, error: null, data: payload.data, fetchType: payload.requestType },
    FAILURE: { loading: false, error: payload.error, data: null, fetchType: payload.requestType }
}[status]);

// Reducer
const BlisterPackingReducer = (state = initialState, { type, payload }) => {
    const typeParts = type.split('_');
    const status = typeParts.pop();
    const prefix = typeParts.join('_');
    const key = actionPrefixMap[prefix];

    if (!key) return state;

    const updates = getStatusUpdates(status, payload);
    return updates ? updateState(state, key, updates) : state;
};

export default BlisterPackingReducer;
